var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import gql from "graphql-tag";
import { toApiPersonalInformation } from "../transform";
function createCheckoutPendingPropertyPurchase(_a) {
    var personalInformation = _a.personalInformation, input = __rest(_a, ["personalInformation"]);
    return {
        mutation: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      mutation createCheckoutPendingPropertyPurchaseMutation(\n        $input: CreateCheckoutPendingPropertyPurchaseInput!\n      ) {\n        createCheckoutPendingPropertyPurchase(input: $input) {\n          checkoutUrl\n        }\n      }\n    "], ["\n      mutation createCheckoutPendingPropertyPurchaseMutation(\n        $input: CreateCheckoutPendingPropertyPurchaseInput!\n      ) {\n        createCheckoutPendingPropertyPurchase(input: $input) {\n          checkoutUrl\n        }\n      }\n    "]))),
        variables: {
            input: __assign(__assign({}, input), { personalInformation: personalInformation
                    ? toApiPersonalInformation(personalInformation)
                    : undefined }),
        },
    };
}
export default createCheckoutPendingPropertyPurchase;
var templateObject_1;
